<!-- Featured Services Section -->
<section id="featured-services" class="featured-services section">
    <div class="container">
        <div class="row gy-4">
            <div class="col-xl-4 col-lg-6" data-aos="fade-up" data-aos-delay="100">
                <div class="service-item d-flex">
                    <div class="icon flex-shrink-0"><i class="bi bi-receipt-cutoff"></i></div>
                    <div class="details">
                        <h4 class="title">Free and Easy Invoice Creation</h4>
                        <p class="description">Create professional invoices effortlessly without any cost</p>
                    </div>
                </div>
            </div>
            <!-- End Service Item -->

            <div class="col-xl-4 col-lg-6" data-aos="fade-up" data-aos-delay="200">
                <div class="service-item d-flex">
                    <div class="icon flex-shrink-0"><i class="bi bi-file-earmark-pdf"></i></div>
                    <div class="details">
                        <h4 class="title">Instant PDF Downloads</h4>
                        <p class="description">Get your invoices instantly as downloadable PDF files</p>
                    </div>
                </div>
            </div><!-- End Service Item -->

            <div class="col-xl-4 col-lg-6" data-aos="fade-up" data-aos-delay="300">
                <div class="service-item d-flex">
                    <div class="icon flex-shrink-0"><i class="bi bi-pencil"></i></div>
                    <div class="details">
                        <h4 class="title">Professional and Customizable Templates</h4>
                        <p class="description">Customize your invoices with professional templates that suit your business needs</p>
                    </div>
                </div>
            </div><!-- End Service Item -->
        </div>
    </div>
</section>

<!-- /Featured Services Section -->